export default function translate(i18n, propriete) {
  if (propriete === 'libelle') {
    return i18n.t('validation.requiredField.libelle');
  }
  if (propriete === 'adresse.Latitude') {
    return i18n.t('validation.latitude');
  }
  if (propriete === 'adresse.Longitude') {
    return i18n.t('validation.longitude');
  }
  if (propriete === 'newPwd') {
    return i18n.t('validation.password');
  }
  if (propriete === 'emailAddress') {
    return i18n.t('validation.email');
  }
  if (propriete === 'site') {
    return i18n.t('validation.site');
  }
  return propriete;
}



// WEBPACK FOOTER //
// ./src/services/validation/translator.js